import { Navigate, Outlet, useLocation } from "react-router-dom";
import { POST_LOGIN_PATHS } from "@crewledger/shared/beta-access";
import { useAuth } from "@/features/auth/auth-provider";
import { isPathAllowedForRedirect } from "@/features/auth/access-gate";

/** Enforces server-resolved post-login redirects — not just client route guards. */
export function AuthGateLayout() {
  const { ready, authenticated, redirectTo, provisioned } = useAuth();
  const location = useLocation();

  if (!ready) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <p className="text-sm text-muted-foreground">Loading…</p>
      </div>
    );
  }

  if (!authenticated) {
    return <Navigate to="/login" replace />;
  }

  if (
    redirectTo &&
    !isPathAllowedForRedirect(location.pathname, redirectTo, provisioned)
  ) {
    return <Navigate to={redirectTo} replace />;
  }

  if (
    provisioned &&
    redirectTo === POST_LOGIN_PATHS.DASHBOARD &&
    location.pathname === "/login"
  ) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
